module.exports = __webpack_public_path__ + "static/media/location.26efef1d.svg";